import type { MouseEvent } from 'react';
import type { MenuItem } from '~/systems/contextMenu';
import './ContextMenuItem.css';

interface ContextMenuItemProps {
  item: MenuItem;
  onClose: () => void;
}

export default function ContextMenuItem({
  item,
  onClose
}: ContextMenuItemProps) {
  function onClick(event: MouseEvent) {
    onClose();
    item.action(event.nativeEvent);
  }
  return (
    <li
      className="ContextMenuItem"
      role="menuitem"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(e as unknown as MouseEvent);
        }
      }}
    >
      {item.label}
    </li>
  );
}
